import { isNil } from 'lodash';
import ValueFilter from './ValueFilter';

export type NumericConfigComparison = {
  numeric_type: 'comparison';
  comparison?: '<' | '<=' | '=' | '!=' | '>=' | '>';
  value: string;
};

type NumericConfigRange = {
  numeric_type: 'range';
  from_value: string;
  to_value: string;
};

type NumericConfigBasic = {
  numeric_type: 'any' | 'none' | 'non empty';
};

export type NumericFilterConfig =
  | NumericConfigComparison
  | NumericConfigRange
  | NumericConfigBasic;

class NumericFilter extends ValueFilter<NumericFilterConfig> {
  constructor(value?: NumericFilterConfig) {
    super(value || { numeric_type: 'any' });
  }

  get hasValue() {
    return (
      this.value &&
      'numeric_type' in this.value &&
      this.value.numeric_type !== 'any'
    );
  }

  matches(number: number | null | undefined) {
    if (!this.hasValue) return true;

    switch (this.value.numeric_type) {
      case 'any':
        return true;
      case 'none':
        return isNil(number);
      case 'non empty':
        return !isNil(number);
      case 'range': {
        if (typeof number !== 'number') {
          return false;
        }
        const from = Number(this.value.from_value);
        const to = Number(this.value.to_value);
        return number >= from && number <= to;
      }
      case 'comparison': {
        const value = Number(this.value.value);

        switch (this.value.comparison) {
          case '=':
            return number === value;
          case '!=':
            return number !== value;
          case '<':
            return number < value;
          case '<=':
            return number <= value;
          case '>':
            return number > value;
          case '>=':
            return number >= value;
        }
      }
    }

    return true;
  }

  clearItems() {
    this.set({ numeric_type: 'any' });
  }
}

export default NumericFilter;
